import React from "react";
const Anchorable = ({ nodeId, children }) => {
  return React.cloneElement(React.Children.only(children), { id: `viewer-${nodeId}` });
};
var Anchorable_default = Anchorable;
export {
  Anchorable_default as default
};
//# sourceMappingURL=Anchorable.js.map
